<!-- CreateOrder.vue -->
<template>
  <div class="create-order">
    <!-- Keep existing navbar exactly as-is -->
    <div class="nav-bar-operations">
      <img
        src="@/assets/logogruas.png"
        alt="HomePage"
        @click="backMainPanel"
        class="logo-button"
      />
    </div>

    <!-- Header -->
    <header class="header">
      <div class="title">
        <h1>Crear nueva orden</h1>
        <p class="sub">Elige el tipo de servicio para iniciar una orden.</p>
      </div>
    </header>

    <!-- Cards Grid -->
    <section class="grid" aria-live="polite">
      <article
        v-for="card in cards"
        :key="card.key"
        class="card"
        role="link"
        tabindex="0"
        @click="go(card.to)"
        @keyup.enter="go(card.to)"
      >
        <div class="card__media">
          <img :src="card.img" :alt="card.title" />
        </div>

        <div class="card__content">
          <div class="card__title">
            <h2>{{ card.title }}</h2>
            <span class="chip" v-if="card.chip">{{ card.chip }}</span>
          </div>
          <p class="card__text">{{ card.text }}</p>
          <div class="card__actions">
            <router-link class="btn btn--primary" :to="card.to">Crear</router-link>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CreateOrder',
  computed: {
    cards() {
      return [
        {
          key: 'remolque',
          title: 'Remolque',
          text: 'Servicio de traslado de vehículos.',
          img: require('@/assets/A-vial-card.jpg'),
          to: { path: '/new-order-assistance' },
          chip: 'Popular',
        },
        {
          key: 'auxilio',
          title: 'Auxilio vial',
          text: 'Asistencia en carretera y apoyo inmediato.',
          img: require('@/assets/A-auxiliar-card.jpg'),
          to: { path: '/new-order-auxiliar' },
        },
        {
          key: 'montacarga',
          title: 'Montacarga',
          text: 'Movimiento y maniobra con montacargas.',
          img: require('@/assets/Montacarga-card.jpg'),
          to: { path: '/new-order-forklift' },
        },
        {
          key: 'industrial',
          title: 'Industrial',
          text: 'Movimiento y maniobra de servicio industrial.',
          img: require('@/assets/Montacarga-card.jpg'),
          to: { path: '/new-order-industrial' },
        },
        {
          key: 'lote',
          title: 'Lote',
          text: 'Gestión de lotes y resguardo.',
          img: require('@/assets/Lote-card.jpg'),
          to: { path: '/new-order-lot' },
        },
      ]
    },
  },
  methods: {
    backMainPanel() {
      window.location.href = '/main-panel'
    },
    go(to) {
      this.$router.push(to)
    },
  },
}
</script>

<style scoped>
.create-order {
  --bg: #ffffff;
  --panel: #ffffff;
  --muted: #667085;
  --text: #0f172a;
  --brand: #ffc434;
  --primary: #2563eb;
  --ring: rgba(37, 99, 235, 0.28);
  min-height: 100vh;
  background: var(--bg);
  padding: 12vh 16px 48px; /* space for navbar */
}

/* Navbar (kept) */
.nav-bar-operations {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 10vh;
  background-color: var(--brand);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-button {
  height: 70%;
  object-fit: contain;
  cursor: pointer;
}

/* Header */
.header {
  margin: 6px 0 12px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}
.title h1 {
  margin: 0;
  font-size: 1.35rem;
  color: var(--text);
}
.title .sub {
  margin: 4px 0 0;
  color: var(--muted);
  font-size: 0.95rem;
}

/* Grid + Card (same style language as your modern panels) */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 18px;
  margin-top: 8px;
}

.card {
  background: var(--panel);
  border: 1px solid rgba(0,0,0,.08);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,.08);
  transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
  outline: none;
  cursor: pointer;
}
.card:hover { transform: translateY(-3px); border-color: rgba(0,0,0,.12); }
.card:focus { box-shadow: 0 0 0 6px var(--ring); }

.card__media {
  position: relative;
  height: 140px;
  overflow: hidden;
}
.card__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.card__content {
  padding: 14px;
  display: grid;
  gap: 10px;
}
.card__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.card__title h2 {
  font-size: 1rem;
  margin: 0;
  color: #000;
}
.card__text {
  margin: 0;
  color: #444;
  font-size: 0.9rem;
}
.chip {
  font-size: .7rem;
  background: rgba(37,99,235,.12);
  color: #2563eb;
  padding: 4px 8px;
  border-radius: 999px;
  border: 1px solid rgba(37,99,235,.28);
}

.card__actions {
  display: flex;
  justify-content: flex-end;
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid transparent;
  background: var(--panel);
  color: var(--text);
  cursor: pointer;
  text-decoration: none;
  transition: transform .15s ease, box-shadow .2s ease, background .2s ease, color .2s ease;
}
.btn:focus { outline: none; box-shadow: 0 0 0 6px var(--ring); }
.btn--primary { background: var(--primary); color: white; }
.btn--primary:hover { transform: translateY(-1px); box-shadow: 0 8px 22px rgba(37,99,235,.35); }

/* Responsive tweaks */
@media (max-width: 720px) {
  .header { flex-direction: column; gap: 6px; }
}
</style>
